import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/schedule'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(hours) {
    return http.post(`${resource}`, hours)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(hours, uuid) {
    return http.put(`${resource}/${uuid}`, hours)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
